import { ApiService } from "@/api";

export const aggStatusOfGroupDay = (day: {
  year: string;
  month: string;
  date: string;
}) => {
  return ApiService.baseAction(
    "agg/status/group/day",
    {
      params: day,
    },
    "GET"
  );
};
